import React from 'react'
import Button from './Button.js'
import { Fade } from '../Transitions'

const CancelButton = ({ submitting, dirty }) => {
	return dirty
		? <Fade>
				<Button
					disabled={!dirty}
					loading={submitting}
					icon={'close'}
					type={'ghost'}
				/>
			</Fade>
		: null
}

export default CancelButton



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Button/CancelButton.js